;(function ($, window, document) {
    window.Account = Me.view.extend({
        options: {},

        initialize: function () {
            _.bindAll(this, 'addEvents', 'changePassword');
            this.addEvents();
        },
        addEvents: function () {
            this.$el.find('.change-password').on('click', this.changePassword);
        },
        changePassword: function () {
            this.$el.find('.success-message').removeClass('success');
            var view = this;
            var form = this.$el.find('.change-password-form');

            if (!form.hasClass('open')) {
                var totalHeight = 0;
                form.children().each(function (index, value) {
                    totalHeight += parseInt($(value).outerHeight(true));
                });
                form.height(totalHeight);
                form.addClass('open');
            }
            else {
                form.height(0);
                form.removeClass('open');
            }

        }
    });
}(jQuery, window, document));
